import React, { Component } from 'react';
import { Nav, NavDropdown, Navbar, Button } from 'react-bootstrap';


class menu_clientes extends Component {
  constructor(props) {
    const tipo = sessionStorage.getItem('tipo');
    const nombre_empresa = sessionStorage.getItem('nombre');
    const nombre_usuario = sessionStorage.getItem('usuario');
    const company = sessionStorage.getItem('company');

    //dinamic url
    const urlOrders = (tipo === '3' && company === '900130488') ? "/pedidos" : "/pedidosCust";
    const urlReportOrders = (tipo === '3' && company === '900130488') ? "/reportepedidos" : "/reportepedidosCust";
    //
    super(props);
    this.state = {
      currentCompanyName: nombre_empresa,
      currentUserName: nombre_usuario,
      tipo,
      urlOrders,
      urlReportOrders
    }
  }


  render() {
    //const validarTipo = (this.state.currrentType === '0' || this.state.currrentType === '1')
    //const rutaEmpresa = (this.state.currrentType === '0') ? '/empresa' : '/empresa/crear/?' + this.state.currentCompany;
    //const { ped } = this.state;
    //const { currentCompany } = this.state;
    return (
      <div style={{ 'fontSize': 12 }}>
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
          <Navbar.Brand href="/home"><img src="/logopage.png" alt="Gestionar TIC" height="40px" width="150px"></img></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">

            {this.state.tipo !== '3' &&
              <NavDropdown title="Estructuracion" id="collasible-nav-dropdown">
                <NavDropdown.Item href="/formularioCustomer">Cliente</NavDropdown.Item>
              </NavDropdown>}

            <Nav className="mr-auto" >
              <Navbar bg="light" expand="lg">
                <Nav className="mr-auto">
                  <NavDropdown title="Pedidos" id="collasible-nav-dropdown" className="ml-3">
                    <NavDropdown.Item href={this.state.urlOrders} >Crear Pedido</NavDropdown.Item>
                    <NavDropdown.Item href={this.state.urlReportOrders}  >Reporte de pedidos</NavDropdown.Item>
                  </NavDropdown>
                </Nav>
              </Navbar>
              {/* <Nav.Link href="/reportes">Reportes</Nav.Link> */}
            </Nav>

            <Nav>
              <Navbar.Brand><h6>{this.state.currentUserName}</h6></Navbar.Brand>
              <Navbar.Brand><h6>{this.state.currentCompanyName}</h6></Navbar.Brand>

              <Button href="/cerrarsesion" variant="outline-secondary">Cerrar Sesion</Button>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>);
  }
}
export default (menu_clientes);


// WEBPACK FOOTER //
// ./src/components/menu_clientes.jsx